import React from 'react'

import styled from 'styled-components'

import StarRatings from './StarRatings'
import { P } from '../../../../../styles/Typograph.styles'

const FeedbackQuestion = ({ question, value, handleQuestion }) => {
  return (
    <StyledQuestion>
      <P width="50%">{question}</P>
      <StarRatings answer={value} handleRating={handleQuestion} />
    </StyledQuestion>
  )
}

const StyledQuestion = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f9f9;
`

export default FeedbackQuestion
